import { render, staticRenderFns } from "./NotaEmbeddedLayoutDesktop.vue?vue&type=template&id=4b730586&scoped=true&"
import script from "./NotaEmbeddedLayoutDesktop.vue?vue&type=script&lang=js&"
export * from "./NotaEmbeddedLayoutDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NotaEmbeddedLayoutDesktop.vue?vue&type=style&index=0&id=4b730586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b730586",
  null
  
)

export default component.exports